module.exports = __webpack_public_path__ + "media/question1_en.8c16de45.wav";